import { useEffect } from "react";
import { Link } from "react-router-dom";

const LAST_UPDATE = "2 de Setembro de 2026";

const C = {
  bg: "#FFFFFF",
  bgSoft: "#F8FAFC",
  bgDark: "#122457",
  primary: "#2563EB",
  text: "#0F172A",
  textMuted: "#475569",
  border: "#E2E8F0",
};

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: "2.5rem" }}>
      <h2 style={{ fontWeight: 800, fontSize: "1.3rem", color: C.text, marginBottom: "1rem", paddingBottom: "0.5rem", borderBottom: `1px solid ${C.border}` }}>{title}</h2>
      <div style={{ color: C.textMuted, fontSize: "0.93rem", lineHeight: 1.8 }}>{children}</div>
    </div>
  );
}

function P({ children }) {
  return <p style={{ marginBottom: "0.85rem" }}>{children}</p>;
}

function Ul({ items }) {
  return (
    <ul style={{ paddingLeft: "1.25rem", marginBottom: "0.85rem", display: "flex", flexDirection: "column", gap: "0.4rem" }}>
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export default function TermosPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ background: C.bg, color: C.text, fontFamily: "'Inter', sans-serif", minHeight: "100vh" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');`}</style>

      {/* Nav simples */}
      <nav style={{ position: "sticky", top: 0, zIndex: 100, background: "rgba(255,255,255,0.95)", backdropFilter: "blur(16px)", borderBottom: `1px solid ${C.border}`, padding: "1rem clamp(1.5rem,5vw,4rem)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontWeight: 900, fontSize: "1.25rem", color: C.text, textDecoration: "none" }}>
          <span style={{ width: 30, height: 30, borderRadius: 8, background: C.primary, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "0.95rem", fontWeight: 900 }}>R</span>
          RUMO
        </Link>
        <Link to="/" style={{ color: C.textMuted, textDecoration: "none", fontSize: "0.85rem", fontWeight: 600 }}>
          ← Voltar ao site
        </Link>
      </nav>

      {/* Hero */}
      <div style={{ background: `linear-gradient(160deg, ${C.bgDark} 0%, #0B1533 100%)`, padding: "4rem clamp(1.5rem,5vw,4rem) 3rem", color: "#fff" }}>
        <div style={{ maxWidth: 760, margin: "0 auto" }}>
          <p style={{ fontSize: "0.72rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#93C5FD", marginBottom: "0.75rem" }}>Legal</p>
          <h1 style={{ fontWeight: 800, fontSize: "clamp(2rem,5vw,3rem)", letterSpacing: "-0.01em", marginBottom: "0.75rem" }}>Termos e Condições</h1>
          <p style={{ color: "#B9C6E8", fontSize: "0.88rem" }}>Última atualização: {LAST_UPDATE}</p>
        </div>
      </div>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "3.5rem clamp(1.5rem,5vw,4rem) 5rem" }}>

        <Section title="1. Identificação">
          <P>Estes Termos e Condições regulam a utilização da plataforma <strong style={{ color: C.text }}>RUMO</strong>, um serviço de gestão de frota disponível em <strong style={{ color: C.text }}>www.rumo-frota.pt</strong>.</P>
          <P>Ao aceder ou utilizar o serviço, o utilizador aceita integralmente os presentes termos. Em caso de dúvida, contacte: <a href="mailto:geral@rumo-frota.pt" style={{ color: C.primary }}>geral@rumo-frota.pt</a></P>
        </Section>

        <Section title="2. Descrição do serviço">
          <P>A RUMO é uma plataforma de gestão de frota, acessível pela internet, que inclui:</P>
          <Ul items={[
            "Gestão de viaturas, máquinas e outros ativos",
            "Controlo de manutenções e ordens de serviço",
            "Registo de abastecimentos e gestão de depósitos",
            "Controlo de inspeções periódicas",
            "Registo e acompanhamento de avarias",
            "Gestão de seguros, com alertas de renovação",
            "Registo e importação de portagens",
            "Repositório de documentos por viatura",
            "Gestão de obras e centros de custo",
            "Acesso para condutores diretamente do telemóvel, sem instalação",
            "Exportação de relatórios em Excel"
          ]} />
        </Section>

        <Section title="3. Planos e faturação">
          <P><strong style={{ color: C.text }}>Frota 5</strong> — 14,99€/mês · até 5 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 10</strong> — 24,99€/mês · 6 a 10 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 15</strong> — 34,99€/mês · 11 a 15 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 20</strong> — 44,99€/mês · 16 a 20 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 25</strong> — 54,99€/mês · 21 a 25 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 30</strong> — 64,99€/mês · 26 a 30 ativos</P>
          <P><strong style={{ color: C.text }}>Frota 30+</strong> — preço sob consulta · dimensão negociada com a equipa RUMO</P>
          <P>O número de utilizadores incluído em cada plano é definido de acordo com o número de ativos contratados. Todos os preços são em euros e incluem IVA à taxa legal em vigor. A faturação é mensal, com renovação automática, salvo aviso contrário com 30 dias de antecedência.</P>
          <P>O arranque é acompanhado pela equipa RUMO e a importação de dados existentes (por exemplo, de Excel) está incluída sem custo adicional.</P>
        </Section>

        <Section title="4. Período de teste e cancelamento">
          <P>A RUMO oferece uma <strong style={{ color: C.text }}>demonstração gratuita e acompanhada</strong> antes de qualquer compromisso comercial.</P>
          <P>Após subscrição, o cliente pode cancelar a qualquer momento sem penalizações. O cancelamento produz efeitos no final do período faturado em curso.</P>
          <P>Após o cancelamento, o cliente dispõe de <strong style={{ color: C.text }}>90 dias</strong> para exportar os seus dados. Findo este prazo, os dados são eliminados de forma permanente.</P>
        </Section>

        <Section title="5. Contas de utilizador">
          <P>O cliente é responsável por:</P>
          <Ul items={[
            "Manter as credenciais de acesso confidenciais",
            "Gerir as contas dos utilizadores da sua organização",
            "Notificar de imediato a RUMO em caso de acesso não autorizado",
            "Garantir que os seus utilizadores cumprem estes termos"
          ]} />
        </Section>

        <Section title="6. Utilização aceitável">
          <P>O cliente compromete-se a não utilizar a plataforma para:</P>
          <Ul items={[
            "Fins ilegais ou contrários à ordem pública",
            "Introduzir dados falsos ou enganosos",
            "Tentar aceder a dados de outros clientes",
            "Copiar ou tentar reproduzir o funcionamento da plataforma",
            "Revender ou sublicenciar o acesso a terceiros sem autorização",
            "Sobrecarregar deliberadamente o serviço"
          ]} />
        </Section>

        <Section title="7. Disponibilidade do serviço">
          <P>A RUMO empenha-se em garantir a maior disponibilidade possível da plataforma, com monitorização contínua da infraestrutura, excluindo períodos de manutenção programada comunicados com antecedência.</P>
          <P>Em caso de indisponibilidade prolongada e não programada, o cliente será informado e, quando aplicável, poderá ser compensado de forma proporcional, a definir caso a caso com a equipa RUMO.</P>
        </Section>

        <Section title="8. Dados e propriedade">
          <P><strong style={{ color: C.text }}>Os dados introduzidos na plataforma são propriedade exclusiva do cliente.</strong> A RUMO não reivindica qualquer direito sobre esses dados.</P>
          <P>A RUMO trata os dados dos clientes exclusivamente para prestar o serviço contratado, em conformidade com a Política de Privacidade e o RGPD.</P>
          <P>O software, a marca e todos os elementos da plataforma são propriedade intelectual da RUMO e estão protegidos pela legislação aplicável.</P>
        </Section>

        <Section title="9. Confidencialidade">
          <P>Ambas as partes comprometem-se a manter confidenciais todas as informações trocadas no âmbito da relação comercial, nomeadamente dados operacionais, preços negociados e demais informações sensíveis.</P>
        </Section>

        <Section title="10. Limitação de responsabilidade">
          <P>A RUMO não se responsabiliza por:</P>
          <Ul items={[
            "Perdas resultantes de utilização indevida da plataforma",
            "Dados introduzidos incorretamente pelos utilizadores",
            "Indisponibilidade do serviço por causa de força maior",
            "Danos indiretos ou lucros cessantes"
          ]} />
          <P>A responsabilidade máxima da RUMO em qualquer situação fica limitada ao valor pago pelo cliente nos últimos 3 meses de serviço.</P>
        </Section>

        <Section title="11. Alterações ao serviço e aos termos">
          <P>A RUMO reserva-se o direito de atualizar estes termos e as funcionalidades do serviço. Alterações significativas serão comunicadas por email com <strong style={{ color: C.text }}>30 dias de antecedência</strong>.</P>
          <P>A continuação da utilização do serviço após esse prazo implica a aceitação das novas condições.</P>
        </Section>

        <Section title="12. Lei aplicável e foro">
          <P>Estes termos são regidos pela lei portuguesa. Em caso de litígio, as partes submetem-se à jurisdição dos tribunais portugueses, com foro na comarca de Lisboa, sem prejuízo de recurso a meios alternativos de resolução de conflitos.</P>
        </Section>

        <Section title="13. Contacto">
          <P><strong style={{ color: C.text }}>RUMO — Gestão de Frota</strong><br />
          Email: <a href="mailto:geral@rumo-frota.pt" style={{ color: C.primary }}>geral@rumo-frota.pt</a><br />
          Website: <a href="https://www.rumo-frota.pt" style={{ color: C.primary }}>www.rumo-frota.pt</a></P>
        </Section>

        <div style={{ marginTop: "3rem", paddingTop: "2rem", borderTop: `1px solid ${C.border}`, display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
          <Link to="/" style={{ color: C.textMuted, textDecoration: "none", fontSize: "0.85rem" }}>← Voltar ao site</Link>
          <Link to="/privacidade" style={{ color: C.primary, textDecoration: "none", fontSize: "0.85rem" }}>Ver Política de Privacidade →</Link>
        </div>
      </div>
    </div>
  );
}
